import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const Modal = ({ isOpen, onClose, children, fullscreen, size }) => {
  if (!isOpen) return null;

  const sizeClass = size ? ` ink-modal-${size}` : '';

  return (
    <div className="ink-modal-overlay">
      <div className={`ink-modal${fullscreen ? ' ink-modal-fullscreen' : ''}${sizeClass}`}>
        <button className="ink-modal-close-btn" onClick={onClose} title="Cerrar">
            <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="ink-modal-content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;

